import { useAuthenticationContext } from '@festina-life/authentication'

/**
 * Hook used for retrieving whether the configuration component is available and
 * configured in the current environment. Will use the API configuration inside the
 * environment.json file to determine whether the component is available.
 */
export const useConfigurationComponentAvailability = () => {
  const { environmentSettings } = useAuthenticationContext()

  return !!environmentSettings?.REACT_APP_CONFIGURATION_API_ENDPOINT
}
